import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/home/home';
import Service from './components/service/servicepage';
import NoPage from './components/noPage/noPage.js';
import About from './components/about/aboutpage.js';
import Contact from './components/contact/contactpage.js';
import Website from './components/websitedevelopment/websitepage.js';
import Ecommerce from './components/ecommercedevelopment/ecommercepage.js';
import Androidios from './components/android/androidiospage.js';
import Login from './adminPanel/components/login.js';
import Blog from './components/blog/blogpage.js';
import Policy from './components/policy/policy.js';
import Term from './components/policy/term.js';
import ScrollToTop from './scrollToTop.js';
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop /> 

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="service" element={<Service />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="website" element={<Website />} />
          <Route path="ecommerce" element={<Ecommerce />} />
          <Route path="androidios" element={<Androidios />} />
          <Route path="blog" element={<Blog />} />
          <Route path="login" element={<Login />} />
          <Route path="policy" element={<Policy />} />
          <Route path="term" element={<Term />} />
          <Route path="*" element={<NoPage/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
